import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { NavbarTypes } from '../../reducers/layout';
import Logo from '../../images/logo.png';
import UserDefault from '../../images/sidebar/basil/UserDefault';
import PowerButton from '../../images/sidebar/basil/PowerButton';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  Navbar,
  Nav,
  Dropdown,
  NavItem,
  NavLink,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,

} from 'reactstrap';
import { logoutUser } from '../../actions/auth';
// import Joyride, { STATUS } from 'react-joyride';
import { openSidebar, closeSidebar, changeActiveSidebarItem } from '../../actions/navigation';

import adminDefault from '../../images/chat/chat2.png';
import Menu from '../../images/sidebar/basil/Menu';

import Settings from '../../images/sidebar/basil/Settings';



import s from './Header.module.scss';
import config from '../../config';



const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    sidebarStatic,
    openUsersList,
    currentUser,
    sidebarOpened,


  } = useSelector((store) => ({
    sidebarStatic: store.navigation.sidebarStatic,
    sidebarOpened: store.navigation.sidebarOpened,
    openUsersList: store.chat.openUsersList,
    currentUser: store.auth.currentUser,
  }));

  const [menuOpen, setMenuOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);


  const avatar = window.localStorage.getItem('userCompanyLogo') ? config.baseURL + "/" + window.localStorage.getItem('userCompanyLogo') : null;
  const firstUserLetter = currentUser && (currentUser.firstname || currentUser.email)?.[0]?.toUpperCase();


  const toggleNotifications = () => {
    setNotificationsOpen(!notificationsOpen);
  };

  const doLogout = () => {
    dispatch(logoutUser());
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleSidebar = () => {
    dispatch(toggleSidebar());
    // if (this.props.sidebarStatic) {
    //   localStorage.setItem('staticSidebar', 'false');
    //   this.props.dispatch(changeActiveSidebarItem(null));
    // } else {
    //   localStorage.setItem('staticSidebar', 'true');
    //   const paths = this.props.location.pathname.split('/');
    //   paths.pop();
    //   this.props.dispatch(changeActiveSidebarItem(paths.join('/')));
    // }

    if (sidebarStatic) {
      localStorage.setItem('staticSidebar', 'false');
      dispatch(changeActiveSidebarItem(null));
    } else {
      localStorage.setItem('staticSidebar', 'true');
      const paths = location.pathname.split('/');
      paths.pop();
      dispatch(changeActiveSidebarItem(paths.join('/')));
    }

  };


  // switchSidebar() {
  //   if (this.props.sidebarOpened) {
  //     this.props.dispatch(closeSidebar());
  //     this.props.dispatch(changeActiveSidebarItem(null));
  //   } else {
  //     const paths = this.props.location.pathname.split('/');
  //     paths.pop();
  //     this.props.dispatch(openSidebar());
  //     this.props.dispatch(changeActiveSidebarItem(paths.join('/')));
  //   }
  // }

  const switchSidebar = () => {
    if (sidebarOpened) {
      dispatch(closeSidebar());
      dispatch(changeActiveSidebarItem(null));
    } else {
      const paths = location.pathname.split('/');
      paths.pop();
      dispatch(openSidebar());
      dispatch(changeActiveSidebarItem(paths.join('/')));
    }
  };



  const navbarType = localStorage.getItem('navbarType') || 'static';

  const { t } = useTranslation();

  // Slider images from public/images/slider
  const sliderImages = [
    '/images/slider/1.png',
    '/images/slider/2.png',
    '/images/slider/3.png',
    '/images/slider/4.png',
    '/images/slider/5.png'
  ];

  // Slider settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    fade: true,
    cssEase: "linear",
    arrows: false
  };

  return (
    <>
      <Navbar
        className={`${s.root} d-print-none ${navbarType === NavbarTypes.FLOATING ? s.navbarFloatingType : ''}`}
        style={{ zIndex: !openUsersList ? 100 : 0 }}
      >
        <div className="d-flex flex-row justify-content-md-start flex-grow-1 align-content-center align-self-start">
          {/* <div className={`${s.navbarBrand} d-md-none`}>
            <header>
              <Link to="">
                <img className="logo" src={Logo} alt="logo" />
              </Link>
            </header>
          </div>
        </div>

        <div> */}
          <Nav className="my-auto">
            <NavItem>
           
             
              <NavLink className="fs-lg d-md-none" onClick={switchSidebar}>
                <span
                  className={`rounded rounded-lg d-md-none d-sm-down-block`}>
                  <span
                    className={s.headerSvgFlipColor}
                    style={{ fontSize: 30 }}
                  >
                    <Menu />
                  </span>
                </span>
                
              </NavLink>
            </NavItem>
          </Nav>


          <NavLink className={`${s.navbarBrand} d-md-none`}>
            <header>
              <Link to="">
                <img className="logo" src={Logo} alt="logo" />
              </Link>
            </header>
          </NavLink>
        </div>

        <div>
          <Nav className="ms-auto">
            <Dropdown
              nav
              isOpen={notificationsOpen}
              toggle={toggleNotifications}
              id="basic-nav-dropdown"
              className={`${s.notificationsMenu}`}
            >
              <DropdownToggle nav caret className={s.headerSvgFlipColor}>
                <span className={`${s.avatar} rounded-circle float-start me-3`}>
                  {avatar ? (
                    <img
                      src={avatar}
                      onError={(e) => (e.target.src = adminDefault)}
                      alt="..."
                      title={currentUser?.firstname || currentUser?.email}
                    />
                  ) : (
                    <span title={currentUser?.firstname || currentUser?.email}>{firstUserLetter}</span>
                  )}
                </span>
                <span
                  className={`small m-2 d-sm-down-none ${s.headerTitle} ${sidebarStatic ? s.adminEmail : ''}`}
                >
                  {currentUser ? currentUser.email : ''}
                </span>
              </DropdownToggle>
            </Dropdown>

            <Dropdown
              nav
              isOpen={menuOpen}
              toggle={toggleMenu}
              className="tutorial-dropdown pr-4"
            >
              <DropdownToggle nav className={`${s.mobileCog}`}>
                <span className={`${s.headerSvgFlipColor}`}>
                  <Settings />
                </span>
              </DropdownToggle>
              <DropdownMenu end className={`${s.headerDropdownLinks} super-colors`}>
                {currentUser && <DropdownItem href={currentUser.role === "ROLE_COMPANY" ? "/app/edit_profile" : "/admin/edit_profile"}>
                  <span className={s.headerDropdownIcon}><UserDefault /></span>{t("My Account")}
                </DropdownItem>}

                <DropdownItem divider />
                <DropdownItem onClick={doLogout}>
                  <span className={s.headerDropdownIcon}><PowerButton /></span>{t("Log Out")}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Nav>
        </div>
      </Navbar>
      {currentUser && currentUser.role === 'ROLE_COMPANY' && 
      <div className={`${s.banner}`}>
        <Slider {...sliderSettings}>
          {sliderImages.map((image, index) => (
            <div key={index}>
              <div
                style={{
                  backgroundImage: `url('${image}')`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center center',
                  backgroundSize: 'contain',
                  height: '300px', // Adjust height as needed
                  width: '100%'
                }}
              />
            </div>
          ))}
        </Slider>
      </div>
      }

    </>
  );
};
export default Header;
